"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosBrandUpdateInputSchema = exports.APosBrandCreateInputSchema = exports.APosBrandSchema = exports.APosBrandStatusSchema = void 0;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../common/timestamps.schema");
const id_schema_1 = require("../../common/id.schema");
exports.APosBrandStatusSchema = zod_1.z.enum(['active', 'inactive', 'deleted']);
exports.APosBrandSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    brandId: id_schema_1.EntityIdSchema,
    name: zod_1.z.string().min(1).max(100),
    slug: zod_1.z.string().min(1).max(100),
    description: zod_1.z.string().max(500).optional(),
    logoUrl: zod_1.z.string().url().optional(),
    logoKey: zod_1.z.string().optional(),
    productCount: zod_1.z.number().int().nonnegative().default(0),
    activeProductCount: zod_1.z.number().int().nonnegative().default(0),
    status: exports.APosBrandStatusSchema.default('active'),
}).merge(timestamps_schema_1.TimestampsSchema);
exports.APosBrandCreateInputSchema = zod_1.z.object({
    name: zod_1.z.string().min(1).max(100),
    slug: zod_1.z.string().min(1).max(100),
    description: zod_1.z.string().max(500).optional(),
    logoUrl: zod_1.z.string().url().optional(),
    logoKey: zod_1.z.string().optional(),
});
exports.APosBrandUpdateInputSchema = exports.APosBrandCreateInputSchema.partial().extend({
    status: exports.APosBrandStatusSchema.optional(),
});
//# sourceMappingURL=brand.schema.js.map